module.exports = __webpack_public_path__ + "images/ads/lock.2d6f0633d534c6c18f99.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/ads/lock.svg
// module id = Am9a
// module chunks = 0